import { Injectable } from '@angular/core';
import { filter, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IpcService {

  private channels: Record<string, BroadcastChannel> = {};
  public messages: Subject<{ channel: string, data: any }> = new Subject();

  constructor() {}

  private getChannel (name: string) {
    if (!this.channels[name]) {
      const channel = this.channels[name] = new BroadcastChannel(name); 

      channel.onmessage = ((event: any) => {
        const { data } = event;
        this.messages.next({ channel: name, data });
      });
    }

    return this.channels[name];
  }

  send (channel: string, data: any) {
    this.getChannel(channel).postMessage(data);
  }

  onChannelMessage (channel: string) {
    this.getChannel(channel);
    return this.messages.pipe(
      filter(message => message.channel === channel)
    );
  }

}
